"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = Array.isArray;

exports.isFunction = function (input) {
  return typeof input === 'function';
};

exports.isObject = function (obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
};

exports.merge = function (target, source) {
  if (exports.isArray(source) && exports.isArray(target)) {
    source.forEach(function (value, index) {
      target[index] = value;
    });
  } else if (exports.isObject(source) && exports.isObject(target)) {
    Object.assign(target, source);
  }

  return target;
};

var noop = function noop() {};

exports.createDeferred = function () {
  var resolve = noop;
  var reject = noop;
  var promise = new Promise(function (a, b) {
    resolve = a;
    reject = b;
  });
  return {
    resolve: resolve,
    reject: reject,
    promise: promise
  };
};